<template>
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- left -->
      <div class="main-left">
        <!-- tree -->
        <el-tree
            :data="elTree"
            :props="defaultProps"
            node-key="label"
            :default-expanded-keys="['全部']"
            accordion
            @node-click="handleNodeClick"
            class="custom-tree"
            highlight-current
            :expand-on-click-node="false"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }" style="font-size: 12px;">
            <span :name="node.label">
              <i v-if="!data.children"
                 :class="node.expanded ? 'el-icon-openFile' : 'el-icon-closeFiles'"></i>
              <i v-else class="el-icon-openFile"></i>{{ node.label }}
            </span>
          </span>
        </el-tree>
      </div>
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!-- tit -->
        <div class="main-icon">
          <div class="main-icon-a">
            <i :class="iconComes"
               style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #5a5a5a;color: #fff;"></i>
            <span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
          </div>
          <!-- btn1 -->
          <div class="main-icon-b">
            <span style="font-size: 12px;color: #606266;font-weight: bold;">状态:</span>
            <el-dropdown @command="handleCommand" trigger="click">
    <span class="el-dropdown-link" style="font-size: 12px;color: #606266;font-weight: bold;">
      {{ DropDownedName }}<i class="el-icon-down"></i>
    </span>
              <el-dropdown-menu slot="dropdown" class="status-dropdown">
                <el-dropdown-item command="a">可用</el-dropdown-item>
                <el-dropdown-item command="b">禁用</el-dropdown-item>
                <el-dropdown-item command="c" divided>全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="main-icon-c">
            <span
                style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">关键字:</span>
            <el-input size="mini" placeholder="模板名称" v-model="searchValue"
                      @keyup.enter.native="handClick(0)"></el-input>
          </div>
          <!-- btn3 -->
          <div class="main-icon-c">
            <el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini"
                       v-if="!v.auth || (Array.isArray(v.auth) && v.auth.every(auth => $store.getters.hasPermission(auth)))"
                       :style="v.style" @click="handClick(i)">{{ v.title }}
            </el-button>
          </div>
        </div>
        <!-- table -->
        <div class="table">
          <el-table :data="tableData1" v-if="currentTableType === 'tableRows1'" border
                     @row-dblclick="handleDbShowData">
            <el-table-column v-for="(col, inx) in tableRows1" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"  align="center"
                             :min-width="getColumnWidth(col.label,col.prop,tableData1)" header-align="center">
              <template #default="{ row }">
                <!-- 特殊处理状态列 -->
                <template v-if="col.prop === 'state'">
                  <el-tag :type="row.state === '1' ? 'success' : 'danger'"
                          size="small"
                          effect="light"
                          :class="'status-tag status-tag-' + row.state">
                    <i :class="row.state === '1' ? 'el-icon-success' : 'el-icon-error'"></i>
                    {{ row.state === '1' ? '启用' : '禁用' }}
                  </el-tag>
                </template>
                <!-- 其他列保持原样 -->
                <template v-else>
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </template>
            </el-table-column>
            <!-- fixed -->
            <el-table-column fixed="right" label="操作" width="148"
                             v-if="['system:complaintemplate:edit', 'system:nowsickness:edit', 'system:history:edit'].every(perm => $store.getters.hasPermission(perm))"
            >
              <template slot-scope="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleClickEdit(scope.row)" size="mini">编辑</el-button>
                  <el-button :type="scope.row.state === '1' ? 'danger' : 'success' "
                             @click="handleStartOrDisabled(scope.row)" size="mini">
                    {{ scope.row.state === '1' ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <el-table :data="tableData2" border v-else :style="{ width: windowWidth + 'px' }"
                    @row-dblclick="handleDbShowData">
            <el-table-column fixed="left" label="行号" type="index" width="50"></el-table-column>
            <el-table-column v-for="(col, inx) in tableRows2" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData2)" header-align="center">
              <template #default="{ row }">
                <!-- 特殊处理状态列 -->
                <template v-if="col.prop === 'state'">
                  <el-tag :type="row.state === '1' ? 'success' : 'danger'"
                          size="small"
                          effect="light"
                          :class="'status-tag status-tag-' + row.state">
                    <i :class="row.state === '1' ? 'el-icon-success' : 'el-icon-error'"></i>
                    {{ row.state === '1' ? '启用' : '禁用' }}
                  </el-tag>
                </template>
                <!-- 其他列保持原样 -->
                <template v-else>
                  {{ row[col.prop] || ' ' }}
                </template>
              </template>
            </el-table-column>
            <!-- fixed -->
            <el-table-column fixed="right" label="操作" width="148">
              <template slot-scope="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleClickEdit(scope.row)" size="mini">编辑</el-button>
                  <el-button :type="scope.row.state === '1' ? 'danger' : 'success' "
                             @click="handleStartOrDisabled(scope.row)" size="mini">
                    {{ scope.row.state === '1' ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 新增模板 -->
        <el-dialog
            :close-on-click-modal="false"
            :title="templateAddRrEditTtiel"
            :before-close="handleCancelTemplate"
            :visible.sync="tpAddOrEditMedicineDialog"
            class="tpAddOrEditMedicineDialog"
            width="600px">

          <div class="dialog-form-container">
            <el-form
                :model="templateForm"
                :rules="templateRules"
                label-width="100px"
                size="mini"
                ref="templateFormRef"
                :disabled="templateDisabled"
                label-position="right">

              <!-- 第一行：名称 + 科室 -->
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="名称：" prop="name">
                    <el-input
                        v-model="templateForm.name"
                        @input="handleNameChangeCode"
                        placeholder="请输入名称"/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="科室：" prop="deptId">
                    <el-select
                        v-model="templateForm.deptId"
                        placeholder="请选择科室"
                        style="width: 100%">
                      <el-option
                          v-for="item in deptOptions"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 第二行：拼音简码 + 适用范围 -->
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="拼音简码：" prop="pinyin">
                    <el-input
                        :disabled="true"
                        v-model="templateForm.pinyin"
                        placeholder="自动生成"/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="适用范围：" prop="rangeType">
                    <el-select
                        v-model="templateForm.rangeType"
                        placeholder="请选择适用范围"
                        style="width: 100%">
                      <el-option
                          v-for="item in rangeTypeOption"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 第三行：状态 -->
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="状态：" prop="state">
                    <el-select
                        v-model="templateForm.state"
                        placeholder="请选择状态"
                        style="width: 100%">
                      <el-option
                          v-for="item in templateStateOption"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 主诉内容（文本域） -->
              <el-form-item label="内容:" prop="content">
                <el-input
                    type="textarea"
                    v-model="templateForm.content"
                    :rows="3"
                    placeholder="请输入内容"
                    style="width: 100%"/>
              </el-form-item>

              <!-- 备注（文本域） -->
              <el-form-item label="备注：" prop="remark">
                <el-input
                    type="textarea"
                    v-model="templateForm.remark"
                    :rows="3"
                    placeholder="请输入备注"
                    style="width: 100%"/>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer no-line">
            <el-button type="primary" size="mini" @click="handleAddTemplate">确定</el-button>
            <el-button size="mini" @click="handleCancelTemplate" style="margin-left: 10px">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <el-pagination
        class="fixed-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
    >
    </el-pagination>
  </div>
</template>
<script>
import { pinyin } from "pinyin-pro";
import {
  addMedicalRecordTemplate,
  getBeforeHistoryTemplate,
  getComplaintemplate,
  getMedicalRecordTemplate,
  getNowHistoryTemplate,
} from "@/api/reservation/caseHistoryTemplate";
import {
  addBeforeHistoryTemplate,
  addComplainTemplate,
  addNowHistoryTemplate,
  editBeforeHistoryTemplate,
  editComplainTemplate,
  editNowHistoryTemplate,
} from "@/api/reservation/outpatientPhysician";
import { withLoading } from "@/untils/loading";

// 工厂函数：生成空模板表单
const getEmptyTemplateForm = () => ({
  id: null,
  content: '',
  deptId: null,
  name: '',
  pinyin: '',
  rangeType: null,
  remark: '',
  state: 1,
});

// 适用范围选项
const rangeTypeOption = [
  { id: 1, label: '本人' },
  { id: 2, label: '本科室' }
];

// 状态选项
const templateStateOption = [
  { id: 1, label: '启用' },
  { id: 0, label: '禁用' }
];

export default {
  data() {
    return {
      // 树菜单配置
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      elTree: [
        {
          label: '全部',
          path: '',
          title: '',
          icon: 'el-icon-news',
          children: [
            { label: '主诉', id: 1, tableType: 'tableRows1' },
            { label: '既往史', id: 2, tableType: 'tableRows1' },
            { label: '现病史', id: 3, tableType: 'tableRows1' },
          ]
        }
      ],

      // 右侧表格动态宽度
      windowWidth: '',
      searchValue: '',
      CatalogueName: '病历模板',
      DropDownedName: '全部',
      state: null,
      iconComes: 'el-icon-byj',

      loading: false,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,
      currentNode: 1,
      currentTableType: 'tableRows1',

      // 模板对话框控制
      tpAddOrEditMedicineDialog: false,
      templateAddRrEditTtiel: '',
      templateType: null,      // 1:主诉 2:既往史 3:现病史
      templateDisabled: false,

      // 表单数据
      templateForm: getEmptyTemplateForm(),
      templateRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在1到50个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 500, message: '长度在1到500个字符', trigger: 'blur' }
        ]
      },

      // 下拉选项
      rangeTypeOption,
      templateStateOption,
      deptOptions: [],

      // 表格列配置
      tableRows1: [
        { name: "适用范围", prop: "rangeType", op: 'rangeTypeOption' },
        { name: "主诉内容", prop: "content" },
        { name: "备注", prop: "remark" },
        { name: "状态", prop: "state", op: "templateStateOption" },
        { name: "科室名称", prop: "deptName" },
        { name: "创建人", prop: "createName" },
        { name: "创建时间", prop: "createTime" },
        { name: "更新人", prop: "updateId", op: "doctorOptions" },
        { name: "更新时间", prop: "updateTime" }
      ],
      tableRows2: [],  // 病历模板暂时未使用，保留空数组
      tableData1: [],
      tableData2: [],

      // 未使用的映射（保留以便 safeGetMappedValue 引用）
      rangeTypeOption,
      templateStateOption,
      doctorOptions: [],

      // 按钮配置
      headerBtn: [
        { search: "search", title: "搜索", type: "success", style: { marginLeft: "-20px" } },
        { add: "add", title: "新增", type: "warning", auth: ['system:complaintemplate:add', 'system:nowsickness:add', 'system:history:add'] },
      ],
    };
  },

  mounted() {
    this.loadData(1);
    this.deptOptions = this.$store.getters['preload/getDeptListOptions'] || [];
    this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || [];
  },

  methods: {
    // 重置模板表单
    resetTemplateForm() {
      this.templateForm = getEmptyTemplateForm();
      if (this.$refs.templateFormRef) {
        this.$refs.templateFormRef.clearValidate();
      }
    },

    // 新增/保存模板
    async handleAddTemplate() {
      await withLoading(this, '数据提交中...')(async () => {
        try {
          await this.$refs.templateFormRef.validate();
        } catch (error) {
          this.$message.error("请填写完整表单");
          return;
        }

        let apiCall, res;
        const isEdit = !!this.templateForm.id;

        switch (this.templateType) {
          case 1: // 主诉模板
            apiCall = isEdit ? editComplainTemplate : addComplainTemplate;
            break;
          case 2: // 既往史模板
            apiCall = isEdit ? editBeforeHistoryTemplate : addBeforeHistoryTemplate;
            break;
          case 3: // 现病史模板
            apiCall = isEdit ? editNowHistoryTemplate : addNowHistoryTemplate;
            break;
          default:
            return;
        }

        res = await apiCall(this.templateForm);
        if (res.code === 200) {
          this.tpAddOrEditMedicineDialog = false;
          this.resetTemplateForm();
          await this.loadData(this.templateType);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 启用/禁用切换
    async handleStartOrDisabled(row) {
      this.templateForm = JSON.parse(JSON.stringify(row));
      this.templateForm.state = row.state === '1' ? '0' : '1';
      // 设置当前模板类型
      this.templateType = this.currentNode;
      // 直接调用保存（跳过表单验证，因为仅修改状态）
      await withLoading(this, '状态修改中...')(async () => {
        let apiCall;
        const isEdit = true;
        switch (this.templateType) {
          case 1:
            apiCall = editComplainTemplate;
            break;
          case 2:
            apiCall = editBeforeHistoryTemplate;
            break;
          case 3:
            apiCall = editNowHistoryTemplate;
            break;
          default:
            return;
        }
        const res = await apiCall(this.templateForm);
        if (res.code === 200) {
          await this.loadData(this.currentNode);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 编辑按钮
    handleClickEdit(row) {
      const titles = {
        1: '编辑主诉模板',
        2: '编辑既往史模板',
        3: '编辑现病史模板'
      };
      this.templateAddRrEditTtiel = titles[this.currentNode] || '编辑模板';
      this.templateType = this.currentNode;
      this.templateForm = JSON.parse(JSON.stringify(row));
      this.templateForm.state = parseInt(this.templateForm.state);
      this.templateDisabled = false;
      this.tpAddOrEditMedicineDialog = true;
    },

    // 双击查看详情
    handleDbShowData(row) {
      const titles = {
        1: '查看主诉模板',
        2: '查看既往史模板',
        3: '查看现病史模板'
      };
      this.templateAddRrEditTtiel = titles[this.currentNode] || '查看模板';
      this.templateForm = row;
      this.templateDisabled = true;
      this.tpAddOrEditMedicineDialog = true;
    },

    // 名称变化时自动生成拼音简码
    handleNameChangeCode() {
      this.templateForm.pinyin = pinyin(this.templateForm.name, {
        pattern: 'first',
        toneType: 'none',
        separator: ''
      }).toLocaleUpperCase();
    },

    // 取消对话框
    handleCancelTemplate() {
      this.loadData(this.currentNode);
      this.resetTemplateForm();
      this.templateDisabled = false;
      this.tpAddOrEditMedicineDialog = false;
    },

    // 表格列映射
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },

    // 加载数据
    async loadData(val) {
      val = val ?? this.currentNode ?? 1;
      this.currentNode = val;

      const apiMap = {
        1: getComplaintemplate,
        2: getBeforeHistoryTemplate,
        3: getNowHistoryTemplate,
      };
      const apiFunc = apiMap[val];
      if (!apiFunc) {
        console.error(`未找到对应的API函数，val=${val}`);
        return;
      }

      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        state: this.state ?? null,
        condition: this.searchValue || ''
      };

      try {
        const res = await apiFunc(params);
        if (res.code === 200) {
          this.tableData1 = res.data.content || [];
          this.totalSize = res.data.totalSize || 0;
        } else {
          this.$message.error(res.message || '请求失败');
        }
      } catch (error) {
        console.error('加载数据出错:', error);
        this.$message.error('系统异常:请联系管理员!');
      }
    },

    // 树节点点击
    handleNodeClick(data, e) {
      this.currentTableType = data.id === 4 ? 'tableRows2' : 'tableRows1';
      this.currentNode = e.data.id;
      this.searchValue = '';
      this.loadData(data.id);
    },

    // 顶部按钮点击
    async handClick(i) {
      switch (i) {
        case 0:
          await this.loadData(this.currentNode);
          break;
        case 1:
          this.tpAddOrEditMedicineDialog = true;
          this.resetTemplateForm();
          this.templateDisabled = false;
          const titles = {
            1: '新增主诉模板',
            2: '新增既往史模板',
            3: '新增现病史模板'
          };
          this.templateAddRrEditTtiel = titles[this.currentNode] || '新增模板';
          this.templateType = this.currentNode;
          break;
      }
    },

    // 状态下拉筛选
    async handleCommand(command) {
      this.state = command === 'a' ? 1 : command === 'b' ? 0 : null;
      this.DropDownedName = command === 'a' ? '可用' : command === 'b' ? '禁用' : '全部';
      await this.loadData(this.currentNode);
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData(this.currentNode);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData(this.currentNode);
    },

    // 列宽计算（保留原逻辑）
    getColumnWidth(label, prop, tableData) {
      if (!tableData || !tableData.length) return 120;
      const minWidth = 80;
      const padding = 30;
      const contentList = tableData.map(item => item?.[prop] ?? '');
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });
      return Math.max(minWidth, ...widths);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__header {
  padding: 18px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #fff;
}

.status-dropdown .el-dropdown-menu__item {
  font-size: 12px !important;
  color: #606266 !important;
}

.status-dropdown .el-dropdown-menu__item:hover {
  color: #409EFF !important;
  background-color: #f5f7fa !important;
}
/* 主容器 - 使用视口高度确保填满屏幕 */
.MedicenCata {
  height: 100%; /* 关键：改为视口高度 */
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 主体内容区 - 弹性布局 */
.main {
  flex: 1;
  display: flex;
  min-height: 0; /* 关键：允许在flex布局中缩小 */
  overflow: hidden;
}

/* 左侧菜单 - 固定宽度 */
.main-left {
  width: 10%;
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid #e4e7ed;
  background: #f8f9fa;
  flex-shrink: 0; /* 关键：防止被压缩 */

  .custom-tree {
    padding: 10px;

    .custom-tree-node {
      font-size: 12px;
      padding: 6px 0;
    }
  }
}

/* 右侧内容区 - 弹性布局 */
.main-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0; /* 关键：允许在flex布局中缩小 */
  overflow: hidden;
}

/* 工具栏 - 防止被压缩 */
.main-icon {
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  flex-shrink: 0; /* 关键：防止工具栏被压缩 */
  min-height: 60px;
  flex-wrap: nowrap; /* 关键：防止换行 */
  overflow-x: auto; /* 关键：允许水平滚动 */
  white-space: nowrap; /* 关键：防止文字换行 */

  .main-icon-a {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .title-icon {
      border-radius: 50%;
      font-size: 20px;
      padding: 6px;
      margin-left: 8px;
      background-color: #5a5a5a;
      color: #fff;
    }

    .title-text {
      font-size: 12px;
      font-weight: bold;
      margin-left: 12px;
      color: #606266;
    }
  }

  .main-icon-b,
  .main-icon-c {
    margin-left: 28px;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .main-icon-c .el-input {
    width: 150px;
    min-width: 150px;
  }

  /* 按钮样式 */
  .el-button {
    flex-shrink: 0;
    white-space: nowrap;
    margin-left: 8px;
  }
}

/* 表格容器 - 可滚动 */
.table {
  flex: 1;
  overflow: auto;

  .el-table {
    width: 100% !important;
    min-width: 800px; /* 关键：确保表格最小宽度 */

    /deep/ .cell {
      font-size: 12px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /deep/ .el-table__body-wrapper {
      overflow-x: auto; /* 关键：表格水平滚动 */
    }
  }
}

.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 180px);
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .main-icon {
    overflow-x: auto;

    .main-icon-c .el-input {
      width: 120px;
      min-width: 120px;
    }
  }

  .table .el-table {
    min-width: 1000px;
  }
}

@media screen and (max-width: 768px) {
  .main {
    flex-direction: column;
  }

  .main-left {
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 200px;
  }

  .main-right {
    height: calc(100vh - 200px - 52px);
  }

  .fixed-pagination {
    left: 0;
  }
}
</style>